module.exports = __webpack_public_path__ + "r-v3/img/ico_save_study_white.f61c0281.svg";